// extracted by mini-css-extract-plugin
export default {"folder-description":"taRz3","folderDescription":"taRz3"};